<template>
    <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition"
              v-model="dialog">
        <v-card>
            <v-toolbar color="primary" dark>
                <v-btn @click.native="dialog = false" dark icon>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Detalji</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-toolbar-items>
                    <v-btn @click.native="saveItem(false)" color="primary" depressed large>Spremi i novo</v-btn>
                    <v-btn @click.native="saveItem(true)" color="primary" depressed large>Spremi</v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-progress-linear :indeterminate="loading" height="4" style="padding:0; margin:0;"></v-progress-linear>

            <form-generator :resource="resource" :table="table" v-if="dialog"></form-generator>
        </v-card>
    </v-dialog>
</template>

<script>

    import {serverBus} from "../../main";

    import FormGenerator from "../add/FormGenerator";

    export default {

        components: {
            FormGenerator
        },

        created: function () {
            serverBus.$on('show-add-edit-dialog', (table, resource) => {
                this.table = table;
                this.resource = resource;

                this.dialog = true;

                setTimeout(function () {
                    serverBus.$emit('get-add-view-data');
                }, 30);
            });

            serverBus.$on('close-add-view-dialog', () => {
                this.dialog = false;
            })
        },

        methods: {
            saveItem(dialog) {
                serverBus.$emit('save-add-view-data', dialog);
            },
        },

        data: function () {
            return {
                dialog: false,
                loading: false,
                table: '',
                resource: {}
            }
        },

    }
</script>

<style>
    form-generator {
        margin-top: 20px;
    }
</style>